export default ($api) => ({
  cauHinhHeThong: (data) => {
    return $api.get(`Cau-hinh-he-thong`, { params: data })
  },
})